import * as HLF from "html-living-framework";
import { Application } from "../Application";
import { ElementData } from "../Data/ElementData";
import * as SFX from "../Data/SoundEffectKeys";
import { BoxCollider } from "../Physics/BoxCollider";
import { ICollider } from "../Physics/ICollider";
import { IPhysicsBody } from "../Physics/IPhysicsBody";

export class WorldElement extends PIXI.Container implements IPhysicsBody {
    protected _active: boolean;
    protected _collider: ICollider | undefined;
    protected _data: ElementData | undefined;
    protected _collisionSfx: string | undefined;
    protected _markedForRemoval: boolean;

    protected _image: PIXI.Sprite | undefined;

    constructor() {
        super();
        this._active = true;
        this._markedForRemoval = false;
    }

    public get image(): PIXI.Sprite | undefined {
        return this._image;
    }

    public get data(): ElementData {
        return this._data!;
    }

    public get rightEdge(): number {
        return this.position.x + this.width;
    }

    public get collider(): ICollider | undefined {
        return this._collider;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(pValue: boolean) {
        this._active = pValue;
    }

    public get flipped(): boolean {
        if (this._image !== undefined) {
            return this._image.scale.x < 0;
        }
        return false;
    }

    public set flipped(pValue: boolean) {
        if (this._image !== undefined) {
            this._image.anchor.x = pValue ? 1 : 0;
            this._image.scale.x = pValue ? -1 : 1;
        }
    }

    public set imageScale(pValue: number) {
        if (this._image !== undefined) {
            this._image.scale.set(pValue);
            this._image.scale.x *= this._image.anchor.x === 0 ? 1 : -1;
        }
    }

    public get markedForRemoval(): boolean {
        return this._markedForRemoval;
    }

    public init(pData: ElementData): void {
        this._data = pData;
        if (this._image === undefined) {
            this._image = new PIXI.Sprite();
            this.addChild(this._image);
        }
        this._image.anchor.set(0, 1);
        this._image.scale.set(1);
        if (this._data.sheet === undefined) {
            this._image.texture = PIXI.loader.resources[this._data.asset].texture;
        }
        else {
            this._image.texture = PIXI.loader.resources[this._data.sheet].textures![this._data.asset];
        }
        this._active = pData.collision;
        if (pData.collision) {
            if (pData.collider) {
                this._collider = pData.collider;
            }
            else {
                this._collider = BoxCollider.fromSprite(this._image);
            }
            if (pData.collisionSfx !== undefined) {
                if (typeof(pData.collisionSfx) === "string") {
                    this._collisionSfx = pData.collisionSfx;
                }
                else {
                    this._collisionSfx = HLF.ArrayUtils.random(pData.collisionSfx);
                }
            }
            else {
                this._collisionSfx = HLF.ArrayUtils.random(SFX.IMPACT_BUILDING);
            }
        }
    }

    public update(pDeltaTime: number): void {
        // Override
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        this._active = false;
        if (this._collisionSfx !== undefined) {
            Application.instance.audio.play(this._collisionSfx, 1, false, HLF.AudioCategory.SFX);
        }
    }

    public cleanup(): void {
        // Override
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        this.cleanup();
        super.destroy(pOptions);
    }
}
